import { fromGraphApplet } from "shared/components/applet_card/from_graph_applet"

const basePublishedAppletsMapper = (
  fieldName,
  data,
  timePeriodInDays,
  timePeriodMetric
) => {
  const referenceObject = fieldName
    ? data.service_metrics[fieldName][0].metrics
    : data.service_metrics.metrics
  return {
    newUsersThisPeriod: referenceObject[0][`new_users_${timePeriodMetric}`],
    topPublishedApplets: (
      referenceObject[0][`top_published_applets_${timePeriodMetric}`] || []
    )
      .filter(a => a.normalized_applet)
      .map(topPublishedApplet => ({
        user_count: topPublishedApplet.user_count,
        applet: fromGraphApplet(topPublishedApplet),
      })),
  }
}

export const topPublishedAppletsMapper = basePublishedAppletsMapper.bind(
  null,
  null
)
export const worksWithTopPublishedAppletsMapper = basePublishedAppletsMapper.bind(
  null,
  "works_with_metrics"
)
export const categoryTopPublishedAppletsMapper = basePublishedAppletsMapper.bind(
  null,
  "category_metrics"
)
